import { Hidden } from '@material-ui/core';
import React, { useContext } from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { OfficerAdminAppKeys, OfficerAdminContext } from '../../../../global/models/officer-admin-model';
import { SearchProps } from '../../models/arc-epi-props';
import { Officer } from './institution-officers-models';

interface OfficerItemProps {
	item: Officer;
	onSetOfficer: (guid: string) => void;
	reIniviteOfficer: (guid: string) => void;
	removeOfficer: (officer: Officer) => void;
	settings: SearchProps;
	showAction: boolean;
	showRemove: boolean;
}

export const OfficerAdminItemView = (props: OfficerItemProps) => {
	const { item, onSetOfficer, reIniviteOfficer, removeOfficer, settings, showAction, showRemove } = props;

	const classes = buttonStyles();
	const app = useContext(OfficerAdminContext);
	const keys = Object.keys(item?.roles);
	const isOnlyDioAdmin = keys?.map(k => item?.roles[k]?.role_name)?.includes('DiocesanAdministrator') && keys?.map(k => item?.roles[k]?.role_name)?.length === 1;
	const hasNonImplicit = keys?.map(k => item?.roles[k]?.implicit)?.includes(false);
	const renderAction = () => {
		if (!hasNonImplicit) {
			return <div>N/A</div>;
		}

		return (
			<div className='sort-table-row-cell-actions'>
				<Hidden smUp>
					<p className='input-label'>{settings?.groupAdminsActionLabel}</p>
				</Hidden>
				{
					item?.has_previous_invitation &&
					<button type='button' className={classes.linkButton} onClick={() => { reIniviteOfficer(item.guid); }} >{settings?.reinviteButtonText || 'Re-invite'}</button>
				}

				{showRemove && item?.business_email && !isOnlyDioAdmin && hasNonImplicit ?
					<button type='button' className={`${classes.linkButton} red-link`} onClick={() => { removeOfficer(item); }}>{settings?.removeButtonText || 'Remove'}</button>
					: null}
			</div>

		);
	};

	const renderAdminName = () => {

		const middleName = item?.middle_name ? ` ${item?.middle_name}` : '';
		const fullName = `${item?.last_name}, ${item.first_name} ${middleName}`;

		if (item?.implicit) {
			return (
				<p>{fullName} <span className='red-text'>*</span></p>
			);
		}

		return (
			<button
				type='button'
				className={classes.linkButton}
				onClick={() => onSetOfficer(item?.guid)}
			>
				{fullName}
			</button>
		);
	};

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{app === OfficerAdminAppKeys.officer ? settings?.officerUsernameLabel : settings?.groupAdminsUsernameLabel}</p>
				</Hidden>
				<div className='sort-table-row-cell-name'>
					{
						item?.clergy &&
						<svg className='clergy-icon' aria-hidden='true' focusable='false'>
							<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
						</svg>
					}
					<div className='sort-table-row-cell-name-text'>
						{renderAdminName()}
					</div>
				</div>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{app === OfficerAdminAppKeys.officer ? settings?.officerBusinessPhonenumber : settings?.groupAdminsBusinessPhonenumber}</p>
				</Hidden>
				{item?.business_phone}
			</div>

			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{app === OfficerAdminAppKeys.officer ? settings?.officerEmailAddressLabel : settings?.groupAdminsEmailAddressLabel}</p>
				</Hidden>
				{item?.business_email}
			</div>

			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.groupAdminsRoleLabel}</p>
				</Hidden>
				{Object.keys(item?.roles).map(role => (
					<div key={role}>{settings?.officersRoleMapping?.find(roleNameMap => roleNameMap?.key === item?.roles[role]?.role_name)?.value || item?.roles[role]?.role_name}</div>
				))}
			</div>
			{
				showAction &&
				<div className='sort-table-row-cell'>
					{renderAction()}
				</div>
			}
		</div>
	);

};
